export const NEXT_PAGE = 'NEXT_PAGE';
export const PREV_PAGE = 'PREV_PAGE';
export const SET_PAGE = 'SET_PAGE';

const initialState = {
  activePage: 0
};

export default (state = initialState, action) => {
  switch (action.type) {
    case NEXT_PAGE:
      return {
        ...state,
        activePage: state.activePage + 1,
      };

    case PREV_PAGE:
      return {
        ...state,
        activePage: state.activePage - 1,
      };

    case SET_PAGE:
       return {
         ...state,
         activePage: action.index,
       };

    default:
      return state;
  }
};

export const nextPage = () => {
  return dispatch => {
    dispatch({
      type: NEXT_PAGE
    });
  };
};

export const prevPage = () => {
  return dispatch => {
    dispatch({
      type: PREV_PAGE
    });
  };
};

export const setPage = () => {
  return dispatch => {
    dispatch({
      type: SET_PAGE
    });
  };
};



// WEBPACK FOOTER //
// ./src/modules/activePage.js